import {
    SET_BULK_ORDER_SAVE
} from "./BulkOrderSaveType"

const initialState = {
    bulkOrderSaveValue: null
}


const reducer = (state = initialState, action: any) => {
    if (action.type === SET_BULK_ORDER_SAVE) {
        return {
            ...state,
            bulkOrderSaveValue: action.bulkOrderSaveValue
        }
    }
    else {
        return state;
    }
};

export default reducer;